// CARO. Casa de estilo · UI translations, French (served under /fr).
// Same key set as the ES dictionary in dictionary.ts (tests/dictionary.test.ts).
// Translated from the Spanish (source of truth). Vouvoiement throughout; no em dash.

import type { Dict } from '@/client/i18n/dictionary';

export const fr: Dict = {
  announcement:
    'Livraison offerte dans la zone euro dès 50 € (beauté et style uniquement) · Sélection personnelle de CARO',
  'announcement.fuel': 'Livraisons avec supplément carburant temporaire',
  'announcement.fuelMore': 'En savoir plus sur le supplément de livraison',
  'announcement.fuelInfo':
    'Avec la hausse du carburant, les transporteurs ont augmenté leurs tarifs. Pour le moment, la livraison comprend un supplément temporaire, détaillé lors du paiement. La livraison offerte dès 50 € dans la zone euro est maintenue. Nous le retirerons dès que les prix du transport seront revenus à la normale.',

  'nav.shop': 'Shop',
  'nav.theEdit': 'Edit',
  'nav.journal': 'Edit',
  'nav.caro': 'CARO',
  'nav.instagram': 'Instagram',
  'nav.contact': 'Contact',
  'nav.beauty': 'Beauté',
  'nav.casa': 'Casa',
  'nav.estilo': 'Style',
  'nav.finds': 'Trouvailles',
  'nav.all': 'Tout',
  'nav.about': 'À propos de CARO',
  'nav.philosophy': 'Philosophie',
  'nav.services': 'Services',
  'nav.newsletter': 'La lettre de CARO',

  'a11y.skip': 'Aller au contenu',
  'a11y.menuOpen': 'Ouvrir le menu',
  'a11y.menuClose': 'Fermer le menu',
  'a11y.cart': 'Panier',
  'a11y.breadcrumb': 'Fil d’Ariane',
  'a11y.homeLink': 'CARO. Casa de estilo, accueil',
  'a11y.mainNav': 'Principale',
  'a11y.sectionsNav': 'Rubriques',
  'a11y.menu': 'Menu',
  'a11y.qtyDecrease': 'Diminuer',
  'a11y.qtyIncrease': 'Augmenter',

  'common.addToCart': 'Ajouter',
  'common.enquire': 'Demander des informations',
  'common.onRequest': 'Sur demande',
  'common.priceTbc': 'Prix à confirmer',
  'common.unverified': 'Fiche à vérifier',
  'common.home': 'Accueil',
  'common.viewBeauty': 'Voir la sélection beauté',
  'common.discoverCasa': 'Découvrir Casa',
  'common.readMore': 'Lire la suite',
  'common.loading': 'Chargement…',
  'common.language': 'Langue',
  'common.keepExploring': 'Poursuivre la découverte',
  'common.retry': 'Réessayer',
  'common.loadError': 'La page n’a pas pu être chargée.',
  'common.backHome': 'Retour à l’accueil',
  'common.name': 'Nom',
  'common.email': 'E-mail',
  'common.message': 'Message',
  'common.sending': 'Envoi en cours…',
  'common.sendError': 'L’envoi a échoué. Veuillez réessayer.',
  'common.hours': 'Horaires : du lundi au samedi, de 10 h à 17 h. Autres horaires sur rendez-vous.',

  'states.errorTitle': 'Un problème est survenu',
  'states.errorMsg': 'Veuillez réessayer dans quelques instants.',

  'home.heroStatement': 'Une maison de style, de beauté et de bien-être, à la sélection soignée.',
  'home.ctaPrimary': 'Découvrir la sélection',
  'home.ctaSecondary': 'Découvrez CARO',
  'home.closing.line1': 'Le style pour les femmes qui évoluent.',
  'home.closing.line2': 'Beauté et bien-être, à travers le regard de Carolina.',
  'home.closing.signature': 'CARO SIGNATURE. Mon empreinte. Votre choix.',
  'home.introEyebrow': 'Le regard de CARO',
  'home.introTitle': 'S’habiller n’est que le début.',
  'home.introBody':
    'Cap sur L’ÉLÉGANCE QUI LAISSE UNE EMPREINTE.\n\nLa mode change. La vie aussi.\n\nSAVOIR CHOISIR\nComprendre ce qui mérite d’entrer dans votre garde-robe, votre trousse de beauté et votre maison.\n\nSAVOIR PORTER\nParce qu’un vêtement, un parfum ou un accessoire changent selon la personne qui les porte.\n\nSAVOIR ÊTRE\nPrésence, caractère, éducation, culture et cette élégance qui ne dépend pas de ce que vous portez. La véritable présence commence là où s’arrête le miroir. L’image attire l’attention. La manière d’être laisse une empreinte.',
  'home.introTodo': 'CARO | Casa de estilo s’adresse aux femmes qui ne veulent pas tout suivre, mais apprendre à choisir et à IDENTIFIER ce qui les représente vraiment.',
  'home.aboutLink': 'À propos de CARO →',
  'home.editorialEyebrow': 'Notre regard sur la beauté',
  'home.editorialTitle': 'Moins de produits. De meilleurs rituels.',
  'home.editorialBody':
    'Nous croyons aux routines simples et efficaces, pensées pour une peau qui évolue. Une sélection réfléchie, des ingrédients qui tiennent parole et le plaisir d’un geste quotidien. Sans promesses impossibles.',
  'home.casaEyebrow': 'Casa',
  'home.casaTitle': 'Objets de la maison de CARO',
  'home.casaLede': 'Art et design de collection. Des pièces choisies, souvent uniques.',
  'home.preparing': 'Sélection en préparation…',

  // Poster hero (editorial cover, replicates the printed portada)
  'home.poster.brandSub': 'Casa de estilo',
  'home.poster.tagline': 'Style · Beauté · Présence · Casa',
  'home.poster.title': 'S’habiller n’est que le début.',
  'home.poster.subLead': 'Pour les femmes qui ne veulent pas tout suivre, mais apprendre à choisir ',
  'home.poster.subAccent': 'ce qui les représente vraiment.',
  'home.poster.needTo': 'Savoir',
  'home.poster.choose': 'Choisir',
  'home.poster.wear': 'Porter',
  'home.poster.be': 'Être',
  'home.poster.byLabel': 'Par',
  'home.poster.byName': 'Carolina Collaer',
  'home.poster.closing': 'Votre style peut se voir. Votre présence doit se ressentir.',
  'home.about.eyebrow': 'Qui est CARO',
  'home.about.title': 'Conseil en image à Sitges, dans le Garraf, le Penedès et à Barcelone',
  'home.about.body1':
    'Je suis Carolina Collaer, {services|conseillère en image et personal shopper}. Je vous accompagne pour choisir ce qui vous représente vraiment, en présentiel ou en ligne.',
  'home.about.body2':
    'Vous pouvez aussi découvrir {shop|ma boutique en ligne}, avec des sélections exclusives de mode, de beauté et de maison, {instagram|me suivre sur Instagram} ou rester informée avec {letter|La lettre de CARO}.',

  'ig.title': 'Sur Instagram',
  'ig.altFallback': 'Publication Instagram de Carolina Collaer',
  'testimonials.eyebrow': 'Confiance',
  'testimonials.title': 'Ce qu’on en dit',
  'testimonials.item': 'Témoignage',
  'testimonials.placeholder': '(texte provisoire)',

  'newsletter.eyebrow': 'Communauté',
  'newsletter.title': 'Recevez la Lettre de CARO.',
  'newsletter.body': 'Une fois par mois, vous recevrez cette lettre avec des idées, des trouvailles, les nouveautés à venir chez CARO et des petits secrets sur le style, la beauté, la présence et la maison. Une lettre pour vous inspirer, découvrir et mieux choisir.',
  'newsletter.placeholder': 'vous@email.com',
  'newsletter.submit': 'Je m’inscris',
  'newsletter.sending': 'Envoi en cours…',
  'newsletter.done': 'Merci. Consultez votre boîte mail pour confirmer.',
  'newsletter.consent': 'J’accepte de recevoir ce que j’ai coché et j’accepte la politique de confidentialité.',
  'newsletter.consentLetter': 'J’accepte de recevoir la lettre de CARO et j’accepte la politique de confidentialité.',
  'newsletter.consentFinds': 'J’accepte de recevoir les alertes Trouvailles de CARO et j’accepte la politique de confidentialité.',
  'newsletter.listsLegend': 'Ce que vous souhaitez recevoir',
  'newsletter.list.letter': 'La lettre de CARO · une fois par mois',
  'newsletter.list.finds': 'Trouvailles de CARO · seulement lors d’un drop',
  'newsletter.listsError': 'Choisissez au moins une option : la lettre ou les Trouvailles.',
  'newsletter.error': 'Vérifiez votre adresse e-mail et cochez la case de consentement.',
  'newsletter.honeypot': 'Ne pas remplir',

  // /newsletter page (the shared Newsletter form sits below this copy)
  'newsletterPage.eyebrow': 'Communauté',
  'newsletterPage.title': 'Recevez la Lettre de CARO.',
  'newsletterPage.lede': 'Une fois par mois, vous recevrez cette lettre avec des idées, des trouvailles, les nouveautés à venir chez CARO et des petits secrets sur le style, la beauté, la présence et la maison.',
  'newsletterPage.p1': 'Une lettre pour vous inspirer, découvrir et mieux choisir.',
  'newsletterPage.p2': 'Et si vous aimez les pièces uniques, inscrivez-vous aussi aux Trouvailles : je ne vous écris que lorsqu’un drop arrive.',
  'newsletterPage.signoff': 'Avec affection,',
  'newsletterPage.signature': 'Carolina Collaer',
  'newsletterPage.imageAlt': 'Carolina Collaer, fondatrice de CARO. Casa de estilo',
  'newsletterPage.formTitle': 'Faites partie de CARO.',
  'newsletterPage.formBody': 'Laissez-moi votre e-mail et confirmez votre inscription grâce au lien que vous recevrez.',
  'newsletterPage.unsubTitle': 'Vous souhaitez vous désinscrire ?',
  'newsletterPage.unsubBody':
    'Chaque lettre se termine par un lien pour vous désinscrire en un clic, quand vous le souhaitez. Si vous ne le trouvez pas, écrivez-moi et je vous désinscrirai moi-même.',
  'newsletterPage.unsubLink': 'Demander la désinscription par e-mail',
  'newsletterPage.unsubSubject': 'Désinscription de La lettre de CARO',
  'newsletterPage.privacyLead': 'Vos données sont traitées conformément à notre',
  'newsletterPage.privacyLink': 'politique de confidentialité',
  'newsletterPage.archiveTitle': 'Lettres envoyées',
  'letter.formTitle': 'Vous voulez recevoir la prochaine ?',
  'letter.readArticle': 'Lire l’article',
  'letter.notFoundTitle': 'Lettre introuvable',
  'letter.notFoundMsg': 'Cette lettre n’a peut-être pas encore été envoyée.',

  'cart.title': 'Votre sélection',
  'cart.empty': 'Votre panier est vide.',
  'cart.subtotal': 'Sous-total',
  'cart.note': 'Livraison et taxes calculées lors du paiement.',
  'cart.checkout': 'Passer commande',
  'cart.remove': 'Retirer',
  'cart.size': 'Taille',
  'cart.pageTitle': 'Panier',
  'cart.emptyTitle': 'Votre panier est vide',
  'cart.emptyMsg': 'La sélection de CARO vous attend.',
  'cart.discoverBeauty': 'Découvrir la sélection beauté',

  'footer.explore': 'Explorer',
  'footer.info': 'Informations',
  'footer.tagline': 'Le style pour les femmes qui évoluent.',
  'footer.tagline2': 'Beauté et bien-être, à travers le regard de Carolina.',
  'footer.signature': 'CARO SIGNATURE. Mon empreinte. Votre choix.',
  'footer.prices': 'Prix en EUR, TVA incluse le cas échéant.',
  'footer.madeBy': 'Site réalisé par',
  'footer.legal.notice': 'Mentions légales',
  'footer.legal.privacy': 'Confidentialité',
  'footer.legal.cookies': 'Cookies',
  'footer.legal.terms': 'Conditions de vente',

  'shop.hubEyebrow': 'Sélection CARO',
  'shop.hubTitle': 'La sélection de CARO',
  'shop.hubCta': 'Découvrir',
  'shop.hubIntro':
    'La sélection personnelle de CARO : style, beauté et objets de design choisis avec discernement. Et, pour vous accompagner, le conseil en image de Carolina.',
  'shop.beauty.title': 'Beauté',
  'shop.beauty.eyebrow': 'Beauté · Sélection CARO',
  'shop.beauty.lede': 'Une cosmétique choisie pour la peau qui évolue.',
  'shop.beauty.intro':
    '## La beauté, avec discernement.\n\n' +
    'Moins de promesses. De meilleurs choix.\n\n' +
    'La beauté évolue, elle aussi, avec nous. La peau change, nos besoins aussi, et surtout la manière dont nous voulons prendre soin de nous.\n\n' +
    'Chez CARO, nous concevons la beauté comme un choix conscient : mieux connaître ce dont nous avons besoin, apprendre à distinguer l’essentiel de l’accessoire et nous entourer de produits qui apportent qualité, plaisir et sens à nos rituels quotidiens.\n\n' +
    '## Peu de formules, bien choisies\n\n' +
    'Cette sélection ne cherche ni à accumuler les nouveautés ni à suivre la dernière tendance. Elle réunit sérums, protection solaire, contour des yeux et masques de marques comme Meisani et Ondo Beauty 36.5, choisis par Carolina pour accompagner la peau qui évolue.\n\n' +
    'Sur chaque fiche, vous trouverez ce que le produit apporte et comment l’utiliser, pour décider en connaissance de cause et sans précipitation.\n\n' +
    '## Savoir choisir, c’est aussi cela\n\n' +
    'Une routine ne s’améliore pas en ajoutant des étapes. Elle s’améliore quand chaque geste a du sens pour vous et que vous le gardez avec constance. Dans l’Edit, nous parlons de beauté du point de vue de l’image et du soin : comment organiser une routine, quelles questions vous poser avant d’acheter et comment vous reconnaître sans chercher à vous corriger.',
  'shop.casa.title': 'Casa',
  'shop.casa.eyebrow': 'Art et design de collection',
  'shop.casa.lede': 'Des objets de caractère, souvent des pièces uniques. Découvrez l’univers de CARO.',
  'shop.casa.intro':
    '## La maison parle aussi de vous.\n\n' +
    'Les objets que vous choisissez, l’art qui vous accompagne, une lampe, un livre ou une pièce singulière construisent l’identité de votre intérieur.\n\n' +
    'Il ne s’agit pas de remplir l’espace, mais de savoir choisir.\n\n' +
    '## Des pièces qui ont une histoire\n\n' +
    'Casa réunit des œuvres et des objets de caractère, souvent des pièces uniques : les sculptures originales de NAOR ou le design d’auteur de Hamed Ouattara, entre autres. Carolina les choisit pour leur regard, leur savoir-faire et l’histoire qu’ils racontent, pas pour la tendance du moment.\n\n' +
    'Ce sont des pièces avec lesquelles on vit pendant des années, pas des objets à changer chaque saison. C’est pourquoi elles méritent d’être choisies sans hâte.\n\n' +
    '## Avant de décider\n\n' +
    'Si une pièce vous intéresse et que vous préférez vous renseigner avant d’acheter, la fiche de nombre d’entre elles vous permet de demander des informations. Nous vous répondrons personnellement.\n\n' +
    '## Une maison qui vous ressemble\n\n' +
    'Chaque objet que vous choisissez dit quelque chose de la personne qui vit avec lui. Dans l’Edit, nous parlons d’art, de design et de la manière de vivre avec les pièces que nous choisissons.',
  'shop.estilo.title': 'Style',
  'shop.hallazgos.title': 'Trouvailles',
  'shop.estilo.eyebrow': 'Style · Sélection CARO',
  'shop.estilo.lede': 'La mode propose. CARO sélectionne. Vous décidez.',
  'shop.estilo.intro':
    '## Ici, vous trouverez ce qui mérite de rester.\n\n' +
    'Parce qu’un beau sac, des lunettes qui ont de la présence, une veste impeccable ou l’accessoire juste ne sont pas de simples compléments. Ce sont des choix. Et quand ils sont bien faits, ils construisent une image cohérente, sans excès.\n\n' +
    '## Moins de pièces, mieux choisies\n\n' +
    'Dans Style, nous réunissons des vêtements et des accessoires que Carolina choisit avec la question qui guide tout CARO : cela a-t-il du sens pour vous ? Maille, vestes, sacs et bijoux en pierre naturelle de maisons comme Surkana, aux côtés du bracelet CARO.\n\n' +
    'Il ne s’agit pas de renouveler votre garde-robe à chaque saison, mais d’ajouter ce qui dialogue avec ce que vous possédez déjà et avec celle que vous êtes aujourd’hui.\n\n' +
    '## Savoir porter\n\n' +
    'Un vêtement, un bijou ou une couleur ne racontent jamais exactement la même histoire sur deux personnes. Dans l’Edit, nous partageons des idées pour porter chaque pièce à votre manière : proportions, associations et ces petits détails capables de transformer une image.\n\n' +
    'Le style apparaît là où la référence s’arrête et où commence votre interprétation.\n\n' +
    'La mode propose. CARO sélectionne. Vous décidez.',
  'shop.servicios.title': 'Conseil en image',
  'shop.servicios.eyebrow': 'Avec Carolina',
  'shop.servicios.lede': 'Un accompagnement personnel en image, style et présence.',
  'shop.allTitle': 'Tout',
  'shop.allEyebrow': 'Sélection CARO',
  'shop.allLede': 'La sélection complète de CARO. Casa de estilo.',
  'shop.emptyTitle': 'Aucune pièce ici pour le moment',
  'shop.emptyMsg': 'Revenez bientôt : la sélection est en préparation.',

  'finds.title': 'Trouvailles',
  'finds.eyebrow': 'Style · Pièces uniques',
  'finds.lede': 'Ce que Carolina déniche en boutique, en voyage et pendant les soldes. Il y en a une de chaque.',
  'finds.intro':
    '## Une de chaque\n\n' +
    'Chaque trouvaille est une pièce que Carolina a dénichée et choisie pour vous : dans une petite boutique, en voyage ou sur le dernier portant des soldes. Pas de réassort. Quand elle part, elle part.\n\n' +
    '## Comment elle choisit\n\n' +
    'Une qualité visible, des pièces qui durent et qui dialoguent avec ce que vous avez déjà, choisies une à une.',
  'finds.newsletterCta': 'Vous pouvez aussi recevoir La lettre de CARO, une fois par mois',
  'finds.letterEyebrow': 'Alerte drop, en direct',
  'finds.letterTitle': 'Soyez prévenue dès qu’une trouvaille arrive.',
  'finds.letterBody': 'Je vous écris dès qu’un drop est en ligne, pas après : des pièces uniques, une de chaque, et la première arrivée l’emporte. Aucun autre e-mail.',
  'finds.emptyTitle': 'La prochaine trouvaille est en route',
  'finds.emptyMsg': 'Carolina cherche. Inscrivez-vous aux alertes Trouvailles et je vous écrirai à l’arrivée du prochain drop.',
  'finds.emptyCta': 'Voir toutes les inscriptions',
  'finds.teaserEyebrow': 'Trouvailles',
  'finds.teaserText': 'Des pièces uniques que Carolina déniche en boutique, en voyage et pendant les soldes. Une de chaque.',
  'finds.teaserCta': 'Voir les trouvailles',
  'finds.story': 'L’histoire',
  'finds.measurements': 'Mesures',
  'finds.condition': 'État',
  'finds.condition.new_with_tags': 'Neuf avec étiquette',
  'finds.condition.new': 'Neuf',
  'finds.condition.excellent': 'Excellent état',
  'finds.condition.good': 'Bon état',

  'pdp.unverifiedLong': 'Fiche à vérifier. Informations officielles en attente',
  'pdp.addToSelection': 'Ajouter à la sélection',
  'pdp.officialInfo': 'Informations produit',
  'pdp.fuelShipping': 'Livraison avec le supplément carburant temporaire :',
  'pdp.zoneSpain': 'Espagne',
  'pdp.zoneEurope': 'Europe',
  'pdp.zoneInternational': 'International',
  'pdp.perPiece': ' (par pièce).',
  'shipping.estimate.handling': 'Préparation {min}-{max} jours ouvrés',
  'shipping.estimate.delivery': 'livraison :',
  'shipping.estimate.zone.es': 'Espagne {min}-{max}',
  'shipping.estimate.zone.europe': 'Europe {min}-{max}',
  'shipping.estimate.zone.international': 'international {min}-{max}',
  'shipping.estimate.total': 'Livraison estimée : {min}-{max} jours ouvrés',
  'pdp.spec.size': 'Format',
  'pdp.spec.benefits': 'Bienfaits',
  'pdp.spec.howToUse': 'Conseils d’utilisation',
  'pdp.spec.ingredients': 'Ingrédients',
  'pdp.spec.inci': 'INCI',
  'pdp.spec.edition': 'Édition',
  'pdp.disclaimer':
    'Les informations officielles sur les ingrédients et la liste INCI prévalent sur toute note éditoriale. Ceci ne constitue pas un avis médical.',
  'pdp.notFoundTitle': 'Produit introuvable',
  'pdp.notFoundMsg': 'Cette pièce n’est peut-être plus disponible.',
  'pdp.enquireTitle': 'Demander des informations',
  'pdp.enquireAlso': 'Vous préférez poser vos questions avant d’acheter ? Demandez des informations',
  'pdp.enquireThanks': 'Merci de votre intérêt. Nous vous répondrons personnellement dans les meilleurs délais.',
  'pdp.sendRequest': 'Envoyer la demande',
  'pdp.soldOutTitle': 'Épuisé',
  'pdp.soldPieceTitle': 'Pièce vendue',
  'pdp.soldPieceText':
    'Cette pièce unique a déjà trouvé sa maison. Si vous cherchez quelque chose du même esprit, la sélection continue de s’enrichir.',
  'pdp.soldPieceLetterTitle': 'Découvrez en avant-première ce qui arrive chez CARO.',
  'pdp.soldFindLetterTitle': 'Ne manquez pas la prochaine trouvaille.',
  'pdp.alternatives': 'Voir la sélection {category}',
  'pdp.unavailable': 'Indisponible pour le moment.',
  'restock.title': 'Prévenez-moi de son retour',
  'restock.body': 'Laissez-nous votre e-mail : nous vous écrirons une seule fois, lorsqu’il sera de nouveau disponible.',
  'restock.submit': 'M’avertir',
  'restock.consent': 'J’accepte que CARO m’écrive au sujet de cette pièce et j’accepte la politique de confidentialité.',
  'restock.alsoLetter': 'Recevoir aussi La lettre de CARO',
  'restock.done': 'Merci. Consultez votre boîte mail pour confirmer l’alerte.',
  'restock.error': 'Vérifiez votre adresse e-mail et cochez la case de consentement.',
  'pdp.available': 'Disponible',
  'pdp.allInCart': 'Vous avez déjà toutes les unités disponibles dans votre sélection.',
  'pdp.size': 'Taille',
  'pdp.chooseSize': 'Choisissez votre taille pour l’ajouter à votre sélection.',
  // Packs (docs/plan-packs.md)
  'pack.badge': 'Pack −{pct} %',
  'pack.includes': 'Comprend :',
  'pack.contents': 'Ce que comprend le pack',
  'pack.savings': 'Vous économisez {amount}',
  'pack.unavailable': 'Ce pack n’est pas disponible pour le moment.',
  'pack.unavailableHint': 'Chaque produit reste visible sur sa propre page.',
  'pack.sizeFor': 'Taille pour {name}',
  'pack.chooseSizes': 'Choisissez une taille pour chaque produit concerné.',
  'pack.notFoundTitle': 'Pack introuvable',
  'pack.notFoundMsg': 'Ce pack n’est peut-être plus disponible.',
  'pack.metaTitle': 'Pack',
  'checkout.packIssueTitle': 'Un pack de votre sélection n’est pas disponible',
  'checkout.packIssueBody': 'Un produit est peut-être épuisé ou une taille manque. Vérifiez le pack ou retirez-le pour continuer.',
  'checkout.packIssueView': 'Voir le pack',
  'pdp.sizeSoldOut': 'Épuisée',
  'pdp.preorderNotice':
    'En réassort : cette pièce est en cours de réapprovisionnement, la livraison prendra donc un peu plus de temps.',
  'product.preorderBadge': 'En réassort',
  'product.editTitle': 'Dans l’Edit',
  'pdp.caroNote': 'Pourquoi CARO l’a choisi',

  'checkout.eyebrow': 'Paiement sécurisé',
  'checkout.title': 'Finaliser la commande',
  'checkout.contact': 'Coordonnées',
  'checkout.phone': 'Téléphone (facultatif)',
  'checkout.email': 'E-mail (obligatoire)',
  'checkout.emailHint': 'Nous vous enverrons la confirmation et le suivi de la livraison.',
  'checkout.firstName': 'Prénom',
  'checkout.lastName': 'Nom',
  'checkout.shipping': 'Livraison',
  'checkout.address': 'Adresse',
  'checkout.city': 'Ville',
  'checkout.zip': 'Code postal',
  'checkout.province': 'Région / Province',
  'checkout.country': 'Pays',
  'checkout.pay': 'Procéder au paiement avec SumUp',
  'checkout.preparing': 'Préparation du paiement…',
  'checkout.secureNote':
    'Le prix, la TVA, les stocks et les totaux sont calculés de manière sécurisée sur le serveur. Le paiement est traité par SumUp ; CARO ne conserve aucune donnée de carte.',
  'checkout.summary': 'Votre sélection',
  'checkout.shippingCalc': 'Livraison calculée à l’étape suivante selon la destination.',
  'checkout.vat': 'TVA incluse',
  'checkout.shippingLabel': 'Livraison',
  'checkout.total': 'Total',
  'checkout.free': 'Offerte',
  'checkout.fuelSurcharge': 'Supplément carburant temporaire',
  'checkout.calculating': 'Calcul en cours…',
  'checkout.shippingPending': 'Calculée selon votre adresse',
  'checkout.shippingNote2': 'Les frais de livraison dépendent de la destination et sont confirmés avec votre adresse.',
  'checkout.customsNote': 'Les envois hors de l’Union européenne peuvent être soumis à des droits de douane et taxes, à la charge de l’acheteur.',
  'checkout.emptyTitle': 'Votre panier est vide',
  'checkout.emptyMsg': 'Ajoutez une pièce de la sélection pour continuer.',
  'checkout.widgetNote':
    'Le paiement par widget nécessite l’activation de SumUp. Passez SUMUP_CHECKOUT_MODE à « hosted » pour tester le parcours complet.',
  'checkout.genericError': 'Impossible de lancer le paiement. Veuillez réessayer.',
  'checkout.error.invalidRequest': 'Certaines informations de la commande ne sont pas valides.',
  'checkout.error.cartInvalid': 'Veuillez vérifier votre panier.',
  'checkout.error.turnstile':
    'La vérification anti-robot a échoué. Veuillez recharger la page et réessayer.',
  'checkout.manualTitle': 'Nous traiterons votre commande par e-mail',
  'checkout.manualBody':
    'Nous n’avons pas pu vérifier votre adresse automatiquement : nous traiterons donc votre commande personnellement par e-mail. Aucun paiement n’a été effectué et le stock n’est pas garanti avant confirmation. Référence :',
  'checkout.addrSuggestTitle': 'Vouliez-vous dire cette adresse ?',
  'checkout.addrSuggestBody': 'Nous avons trouvé une adresse similaire. Vérifiez-la et appliquez-la si elle est correcte :',
  'checkout.addrUse': 'Utiliser cette adresse',
  'checkout.addrKeep': 'Garder la mienne et envoyer comme demande',
  'checkout.addrNotFoundTitle': 'Nous ne trouvons pas votre adresse',
  'checkout.addrNotFoundBody': 'Vérifiez-la et réessayez, ou envoyez-la comme demande pour un traitement manuel (sans paiement, stock non garanti).',
  'checkout.addrRetry': 'J’ai vérifié, réessayer',
  'checkout.addrSendManual': 'Envoyer comme demande',
  'checkout.address2': 'Complément d’adresse facultatif (étage, porte, escalier…)',
  'checkout.addrHelp': 'Confirmez votre adresse pour garantir la livraison avant de payer.',
  'checkout.validate': 'Valider l’adresse',
  'checkout.addrChecking': 'Vérification…',
  'checkout.addrVerified': 'Adresse vérifiée ✓',
  'checkout.addrNone': 'Nous ne trouvons pas cette adresse. Vérifiez-la ou continuez en l’envoyant comme demande.',
  'checkout.addrChoose': 'Choisissez votre adresse :',
  'checkout.addrCheckError': 'Validation impossible pour le moment. Vous pouvez tout de même continuer.',
  'checkout.continue': 'Continuer',
  'checkout.reviewTitle': 'Vérifiez votre commande',
  'checkout.reviewEyebrow': 'Confirmation',
  'checkout.reviewIntro': 'Assurez-vous que tout est correct avant de passer au paiement.',
  'checkout.reviewContact': 'Contact',
  'checkout.reviewShipTo': 'Livrer à',
  'checkout.reviewCost': 'Détail des coûts',
  'checkout.reviewNoPhone': 'Pas de téléphone',
  'checkout.confirmPay': 'Confirmer et payer',
  'checkout.editOrder': 'Revenir et modifier',
  'checkout.acceptPre': 'J’accepte les',
  'checkout.acceptTermsLink': 'Conditions de vente',
  'checkout.acceptMid': 'et j’ai lu la',
  'checkout.acceptPrivacyLink': 'Politique de confidentialité',
  'checkout.reviewShippingPending': 'Confirmée au moment du paiement',
  'checkout.soldOutTitle': 'Nous sommes désolés, cette pièce est désormais épuisée',
  'checkout.soldOutBody':
    'La dernière pièce vient d’être vendue pendant que vous finalisiez votre commande. Nous sommes sincèrement désolés de ce concours de circonstances.',
  'checkout.soldOutContact': 'Souhaitez-vous que nous vous prévenions si elle revient ? Écrivez-nous.',
  'checkout.soldOutBack': 'Retour à la boutique',
  'checkout.backorderTitle': 'En réassort : livraison différée',
  'checkout.backorderBody':
    'Ces articles ne sont plus en stock. La livraison peut prendre plus de temps que d’habitude, généralement entre 1 et 2 semaines. La commande étant expédiée en une seule fois, l’ensemble de la commande arriverait avec ce délai.',
  'checkout.backorderContinue': 'Continuer malgré tout',
  'checkout.backorderRemove': 'Retirer',
  'checkout.sizeRequiredTitle': 'Choisissez une taille',
  'checkout.sizeRequiredBody':
    'Ces pièces sont désormais vendues par taille. Choisissez la vôtre sur la fiche du produit, ou retirez-la du panier pour continuer.',
  'checkout.sizeRequiredFor': 'Choisissez une taille pour',
  'checkout.sizeRequiredChoose': 'Choisir la taille',

  'return.verifying': 'Confirmation de votre paiement…',
  'return.thanks': 'Merci',
  'return.paidTitle': 'Commande confirmée',
  'return.paidBody1': 'Nous avons bien reçu votre paiement. Votre numéro de commande est le',
  'return.paidBody2': 'Nous vous enverrons la confirmation par e-mail si vous nous l’avez communiqué.',
  'return.pendingTitle': 'Paiement en cours de vérification',
  'return.pendingBody1': 'Votre paiement est encore en cours de confirmation. Conservez votre numéro de commande',
  // Starts with the separator after the order number (space before ';').
  'return.pendingBody2': ' ; nous vous préviendrons dès qu’il sera finalisé.',
  'return.failedTitle': 'Le paiement n’a pas abouti',
  'return.failedBody': 'Aucun montant n’a été débité. Vous pouvez réessayer.',
  'return.errorTitle': 'Nous n’avons pas pu vérifier la commande',
  'return.errorBody': 'Si vous pensez que le paiement a bien été effectué, contactez-nous en indiquant votre numéro de commande.',
  'return.contact': 'Contact',

  'about.eyebrow': 'À propos de CARO',
  'about.portrait': 'Portrait de Carolina',
  'about.title': 'Tout a commencé par une question.',
  'about.lede':
    'Pourquoi certaines personnes ont-elles de la présence avant même de parler ?',
  'about.story1':
    'Je suis Carolina Collaer. Pendant des années, j’ai travaillé autour de l’image, de la communication, de l’art, de la mode et du design.',
  'about.story2':
    'Avec le temps, j’ai compris que toutes ces disciplines parlaient, au fond, de quelque chose de semblable : la manière dont nous choisissons de nous présenter au monde.',
  'about.story3':
    'CARO. Casa de estilo est né de ce regard. Pas pour vous dire ce que vous devez porter. Pour partager ce que j’ai appris, continuer à apprendre avec vous et vous aider à développer quelque chose de bien plus intéressant qu’une garde-robe parfaite : votre propre discernement.',
  'about.tags': 'Conseillère en image · Mode et luxe · Art et lifestyle · ES · FR · EN',
  'about.followIg': 'Restons en contact sur Instagram ?',

  'philosophy.title': 'Philosophie',
  'philosophy.lede': 'Le style pour la femme qui évolue.',
  'philosophy.body':
    'Nous croyons que la beauté, le style, le bien-être et la présence forment une seule et même conversation. Et que la sélection vaut plus que le catalogue.\n\n' +
    'Tout a commencé par une question : pourquoi certaines personnes ont-elles de la présence avant même de parler ? CARO. Casa de estilo est né de ce regard. Pas pour vous dire ce que vous devez porter, mais pour vous aider à développer quelque chose de bien plus intéressant qu’une garde-robe parfaite : votre propre discernement.\n\n' +
    '## Savoir choisir\n\n' +
    'Apprendre à distinguer ce qui attire simplement notre regard de ce qui nous représente vraiment. Mieux choisir ne signifie pas avoir moins de possibilités. Cela signifie avoir plus de discernement.\n\n' +
    '## Savoir porter\n\n' +
    'Un vêtement, un parfum, un bijou ou une couleur ne racontent jamais exactement la même histoire sur deux personnes. Le style apparaît là où la référence s’arrête et où commence votre interprétation.\n\n' +
    '## Savoir être\n\n' +
    'La présence ne se construit pas seulement avec ce qui se voit. L’image peut attirer l’attention ; c’est le comportement qui finit par laisser une empreinte.\n\n' +
    '## Style · Beauté · Bien-être\n\n' +
    'Une maison pour la femme qui évolue, à travers le regard de Carolina. La mode propose. CARO sélectionne. Vous décidez.\n\n' +
    'Nous ne prétendons pas établir de règles universelles ni vous dire comment vous devez être. Nous voulons vous offrir des références, des connaissances et des questions qui vous permettent de mieux observer, de questionner davantage et de décider par vous-même.\n\n' +
    'Car plus vous en savez, moins vous avez besoin de suivre.\n\n' +
    '**SAVOIR CHOISIR · SAVOIR PORTER · SAVOIR ÊTRE**',

  'services.colorimetry.eyebrow': 'Test de colorimétrie gratuit',
  'services.colorimetry.text': 'Avant de réserver, découvrez votre saison avec vos cheveux, vos yeux et votre teint, recevez votre fiche PDF personnalisée, gratuite et anonyme, et jouez pour vérifier que vous comprenez votre palette.',
  'services.colorimetry.cta': 'Découvrir ma colorimétrie',
  'services.colorimetry.imageAlt': 'COLORIMETRY ME! : croquis de mode habillé de couleurs de saison et un aperçu de palettes',
  'services.silhouette.eyebrow': 'Test de morphologie gratuit',
  'services.silhouette.title': 'Votre silhouette',
  'services.silhouette.text': 'Répondez à 4 questions devant le miroir, sans mesures ni photo, découvrez votre silhouette et les pièces qui l’équilibrent, repartez avec votre fiche PDF personnalisée, gratuite et anonyme, et jouez à « Choisissez pour l’effet ».',
  'services.silhouette.cta': 'Faire le test de morphologie',
  'services.silhouette.imageAlt': 'Test de morphologie CARO : croquis de mode d’une silhouette en X',
  'services.face.eyebrow': 'Test de forme de visage gratuit',
  'services.face.title': 'Votre visage',
  'services.face.text': 'Répondez à 3 questions devant le miroir, sans photo, découvrez la forme de votre visage et les montures, coiffures, accessoires et contouring qui l’accompagnent, repartez avec votre fiche PDF personnalisée, gratuite et anonyme, et essayez des montures.',
  'services.face.cta': 'Faire le test de visage',
  'services.face.imageAlt': 'Test de forme de visage CARO : croquis d’un visage ovale avec des lunettes papillon',
  'services.eyebrow': 'Image & Présence',
  'services.title': 'Conseil en image et personal shopper à Sitges, dans le Garraf et le Penedès',
  'services.lede': 'Votre image ne commence pas dans la garde-robe.',
  'services.manifesto1': 'Elle commence par comprendre qui vous êtes aujourd’hui, ce que vous voulez transmettre et ce dont vous avez vraiment besoin.',
  'services.manifesto2':
    'CARO vous accompagne pour regarder votre image avec plus de clarté : reconnaître ce qui vous met en valeur, comprendre ce que vous avez déjà, construire de meilleures associations et apprendre à choisir avec plus d’intention.',
  'services.manifesto3': 'Il ne s’agit pas de suivre les tendances, d’accumuler les vêtements ni de devenir quelqu’un d’autre.',
  'services.manifesto4': 'Il s’agit de faire en sorte que votre image vous ressemble.',
  'services.mantra': 'Savoir choisir. Savoir porter. Savoir être.',
  'services.imageAlt': 'Carolina, conseil en image',

  // Où je travaille : the zones themselves come from SERVICE_AREA (config/site.ts).
  'services.area.eyebrow': 'Où je travaille',
  'services.area.body': 'Séances en personne en boutique, à domicile ou sur le lieu de l’événement.',
  'services.area.travel': 'En ligne où que vous soyez, et déplacements en Espagne ou à l’étranger sur demande.',

  // Sub-tabs: personal services vs. brands/stores/groups.
  'services.tabs.label': 'Choisissez le type de conseil',
  'services.tabs.personal': 'Pour vous',
  'services.tabs.pro': 'Marques, boutiques et groupes',
  'services.tabs.proLede':
    'Des expériences autour de l’image pour les boutiques, marques, hôtels, événements privés et groupes.',

  // Pour vous
  'services.svc.sesion.name': 'Séance CARO · Image & Présence',
  'services.svc.sesion.price': '300 €',
  'services.svc.sesion.meta': '4 heures',
  'services.svc.sesion.body1':
    'Une séance personnelle et approfondie, chez vous ou dans l’espace CARO, à partir de votre propre garde-robe.',
  'services.svc.sesion.listTitle': 'Nous analysons :',
  'services.svc.sesion.list':
    'couleurs et tonalités qui vous vont\n' +
    'proportions, silhouettes et volumes\n' +
    'style personnel et moment de vie\n' +
    'vêtements que vous possédez déjà et comment mieux les utiliser\n' +
    'accessoires, lunettes et petits gestes qui transforment un look\n' +
    'maquillage, lorsque c’est pertinent\n' +
    'ce qu’il faut garder, ce qu’il faut reconsidérer et ce qui pourrait vraiment manquer',
  'services.svc.sesion.body2':
    'Pendant la séance, nous créons de nouvelles associations avec vos propres vêtements et repérons les pièces qui pourraient compléter votre garde-robe, sans acheter pour acheter.',
  'services.svc.sesion.body3':
    'Vous recevrez ensuite un compte rendu numérique personnalisé avec les principales conclusions, associations et recommandations travaillées pendant la séance.',
  'services.svc.sesion.note': 'Également disponible en bon cadeau.',

  'services.svc.esencial.name': 'Séance essentielle',
  'services.svc.esencial.price': 'À partir de 120 €',
  'services.svc.esencial.meta': '90 minutes',
  'services.svc.esencial.body1':
    'Pour les moments où vous n’avez pas besoin de revoir toute votre garde-robe, mais d’un regard professionnel et concret.',
  'services.svc.esencial.body2':
    'Elle peut porter sur le style, la couleur, les lunettes, les accessoires, une nouvelle étape professionnelle, un événement, un achat important ou simplement sur ce qui, aujourd’hui, ne fonctionne pas tout à fait dans votre image.',
  'services.svc.esencial.note': 'En présentiel ou en ligne.',

  'services.svc.compras.name': 'Personal shopper · Accompagnement shopping',
  'services.svc.compras.price': 'À partir de 180 €',
  'services.svc.compras.body1': 'Mieux acheter commence avant d’entrer dans une boutique.',
  'services.svc.compras.body2':
    'Nous faisons d’abord le point sur ce dont vous avez besoin, ce qui mérite d’être ajouté et ce que vous devriez cesser d’acheter.',
  'services.svc.compras.body3':
    'Ensuite, je vous accompagne dans une sélection personnalisée de vêtements, d’accessoires ou de lunettes, à la recherche de pièces qui fonctionnent avec votre vie et avec ce que vous avez déjà, pas uniquement avec la tendance du moment.',

  // Marques, boutiques et groupes
  'services.svc.tienda.name': 'Expérience CARO en boutique',
  'services.svc.tienda.price': 'À partir de 300 €',
  'services.svc.tienda.meta': '4 heures',
  'services.svc.tienda.body1':
    'Une expérience autour de l’image pensée pour les boutiques, les marques, les hôtels, les événements privés et les espaces commerciaux.',
  'services.svc.tienda.body2':
    'Nous pouvons créer de courtes séances de couleur, de style, d’accessoires, de lunettes ou de maquillage, d’une durée d’environ 20 minutes par personne.',
  'services.svc.tienda.body3':
    'Une façon différente de susciter la conversation, de créer une expérience et du lien autour du produit.',
  'services.svc.tienda.note': 'Le format s’adapte au lieu, au public et à l’objectif de l’événement.',

  'services.svc.privadas.name': 'Expériences privées',
  'services.svc.privadas.price': 'Selon le format',
  'services.svc.privadas.body1':
    'Anniversaires, rencontres entre amies, événements d’entreprise ou petits groupes.',
  'services.svc.privadas.body2':
    'Nous concevons une expérience autour de l’image, du style et de la présence pour des groupes restreints.',
  'services.svc.privadas.note': 'Tarif selon le format et le nombre de participants.',

  'services.svc.medida.name': 'Sur mesure',
  'services.svc.medida.price': 'Devis personnalisé',
  'services.svc.medida.body1': 'Certains moments n’entrent dans aucune formule.',
  'services.svc.medida.list':
    'Un point ponctuel sur votre garde-robe.\n' +
    'Préparer votre image pour un changement professionnel.\n' +
    'Trouver les lunettes qui vous conviennent.\n' +
    'Construire des tenues pour un voyage.\n' +
    'Vous accompagner dans un achat important.\n' +
    'Un appel vidéo pour répondre à une question précise.',
  'services.svc.medida.body2': 'Dites-moi ce dont vous avez besoin et nous concevrons l’accompagnement adapté.',

  'services.finePrint':
    'Les déplacements en dehors de la zone établie font l’objet d’un devis séparé selon la distance. Les conditions et la durée de chaque service sont confirmées avant la réservation.',
  'services.formTitle': 'Réservez votre conseil en image',
  'services.formCta': 'Demander des informations',
  'services.formThanks': 'Merci. CARO vous écrira très bientôt pour préciser les détails de votre accompagnement.',

  // Service pages (/caro/servicios/<servicio>, docs/plan-tests-y-servicios.md): AI draft for Carolina.
  'services.page.eyebrow': 'Conseil en image · Sitges, Garraf, Penedès et Barcelone',
  'services.page.includesTitle': 'Ce que comprend la séance',
  'services.page.forWhomTitle': 'Pour qui',
  'services.page.howTitle': 'Comment ça se passe',
  'services.page.priceTitle': 'Prix et durée',
  'services.page.testsTitle': 'Avant de réserver, essayez les tests gratuits',
  'services.page.testsText': 'Un premier regard, gratuit et anonyme, que nous confirmons ensuite ensemble pendant la séance.',
  'services.page.othersTitle': 'Autres services',
  'services.page.allServices': 'Tous les services de conseil en image',
  'services.page.more': 'Voir le détail',
  'services.testsLink': 'Voir les trois tests de style gratuits',
  'services.page.sesion.metaTitle': 'Séance de conseil en image à Sitges',
  'services.page.sesion.metaDescription': 'La séance CARO de 4 heures : couleurs, silhouette, garde-robe, lunettes et maquillage avec Carolina Collaer, chez vous à Sitges, Garraf, Penedès, Barcelone.',
  'services.page.sesion.h1': 'Séance de conseil en image à Sitges, dans le Garraf et le Penedès',
  'services.page.sesion.intro': 'La séance complète CARO : quatre heures pour regarder tranquillement vos couleurs, votre silhouette, votre style et votre garde-robe, et créer de nouvelles associations avec ce que vous avez déjà.',
  'services.page.sesion.forWhom': 'Vous voulez revoir votre image en profondeur, pas seulement un détail\nVotre garde-robe est pleine et vous ne savez pas quoi mettre\nVous traversez un moment de changement, professionnel ou personnel\nVous voulez acheter moins et mieux',
  'services.page.sesion.how': 'Nous analysons vos couleurs, vos proportions et votre style\nNous créons des associations avec vos propres vêtements et voyons ce qui pourrait manquer\nVous recevez un résumé numérique avec les conclusions et les recommandations',
  'services.page.esencial.metaTitle': 'Conseil en image en ligne ou en personne',
  'services.page.esencial.metaDescription': 'Séance essentielle de 90 minutes avec Carolina Collaer : couleur, style, lunettes, accessoires, un événement ou un achat important. En personne ou en ligne.',
  'services.page.esencial.h1': 'Séance essentielle de conseil en image, en personne ou en ligne',
  'services.page.esencial.intro': 'Quatre-vingt-dix minutes pour un regard professionnel et concret, quand vous n\'avez pas besoin de revoir toute votre garde-robe.',
  'services.page.esencial.forWhom': 'Vous avez besoin d\'une réponse précise, pas d\'une révision complète\nVous avez un événement, une nouvelle étape professionnelle ou un achat important\nVous voulez trancher une question de couleur, de lunettes ou d\'accessoires',
  'services.page.esencial.how': 'Vous choisissez le sujet : style, couleur, lunettes, accessoires, un événement ou un achat\nNous nous voyons 90 minutes, en personne ou en ligne\nVous repartez avec des réponses concrètes à appliquer dès le lendemain',
  'services.page.compras.metaTitle': 'Personal shopper à Sitges et Barcelone',
  'services.page.compras.metaDescription': 'Personal shopping avec Carolina Collaer : nous définissons ce dont vous avez besoin, puis je vous accompagne pour choisir vêtements, accessoires ou lunettes.',
  'services.page.compras.h1': 'Personal shopper à Sitges, dans le Penedès et à Barcelone',
  'services.page.compras.intro': 'Mieux acheter commence avant d\'entrer dans une boutique : d\'abord nous voyons ce dont vous avez besoin, ensuite je vous aide à le choisir.',
  'services.page.compras.forWhom': 'Vous renouvelez une partie de votre garde-robe sans vouloir vous tromper\nVous achetez beaucoup et portez peu\nVous cherchez une pièce importante : un manteau, un tailleur, des lunettes',
  'services.page.compras.how': 'Nous faisons le point sur ce dont vous avez besoin et ce qui ne vaut pas la peine\nJe vous accompagne dans une sélection personnalisée de vêtements, d\'accessoires ou de lunettes\nNous choisissons des pièces qui vont avec votre vie et avec ce que vous avez déjà',
  'services.page.tienda.metaTitle': 'Événements image pour boutiques et marques',
  'services.page.tienda.metaDescription': 'L\'expérience CARO en boutique : séances courtes de couleur, style, lunettes ou maquillage pour boutiques, marques, hôtels et événements, avec Carolina Collaer.',
  'services.page.tienda.h1': 'Expérience image pour boutiques, marques et hôtels',
  'services.page.tienda.intro': 'Une expérience image qui crée de la conversation et du lien autour de votre produit, dans votre espace.',
  'services.page.tienda.forWhom': 'Boutiques et marques qui veulent rapprocher le produit de leurs clientes\nHôtels et lieux en quête d\'une activité différente\nÉvénements privés et commerciaux',
  'services.page.tienda.how': 'Nous adaptons le format à l\'espace, au public et à l\'objectif\nSéances courtes d\'environ 20 minutes par participante : couleur, style, accessoires, lunettes ou maquillage\nVotre équipe et vos clientes vivent le produit autrement',
  'services.page.privadas.metaTitle': 'Expériences image pour groupes',
  'services.page.privadas.metaDescription': 'Anniversaires, rencontres entre amies ou événements d\'entreprise : une expérience autour de l\'image, du style et de la présence pour petits groupes.',
  'services.page.privadas.h1': 'Expériences privées image et style pour groupes',
  'services.page.privadas.intro': 'Une expérience autour de l\'image, du style et de la présence, conçue pour votre groupe et votre occasion.',
  'services.page.privadas.forWhom': 'Anniversaires et rencontres entre amies\nÉvénements d\'entreprise\nPetits groupes qui cherchent quelque chose de différent',
  'services.page.privadas.how': 'Vous nous racontez l\'occasion et combien vous serez\nNous concevons l\'expérience sur mesure\nLe prix dépend du format et du nombre de participantes',
  'services.page.medida.metaTitle': 'Conseil en image sur mesure',
  'services.page.medida.metaDescription': 'Conseil en image sur mesure avec Carolina Collaer : revoir la garde-robe, un changement professionnel, des lunettes, un voyage ou une question. Sur devis.',
  'services.page.medida.h1': 'Conseil en image sur mesure',
  'services.page.medida.intro': 'Certains moments n\'entrent pas dans une formule : nous concevons l\'accompagnement dont vous avez besoin.',
  'services.page.medida.forWhom': 'Un besoin précis qui ne correspond pas aux séances\nUn voyage, un changement professionnel ou de nouvelles lunettes\nUne question qu\'un appel vidéo peut régler',
  'services.page.medida.how': 'Vous me dites ce dont vous avez besoin\nJe vous propose l\'accompagnement et un devis\nNous le faisons en personne ou en ligne',

  'edit.eyebrow': 'Edit',
  'edit.lede': 'Notes de style, de beauté et de bien-être.',
  'edit.imageAlt': 'Carolina Collaer en trench beige et écharpe',
  'journal.introLede': 'Mieux regarder pour mieux choisir.',
  'journal.intro':
    '## Savoir choisir\n\n' +
    'Apprendre à distinguer ce qui attire simplement notre regard de ce qui nous représente vraiment.\n\n' +
    'Nous parlerons de mode, de couleur, de beauté, de cosmétique, d’accessoires, de parfum, de design, d’objets et de tendances, mais toujours à partir d’une question essentielle : est-ce que cela a du sens pour moi ?\n\n' +
    'Mieux choisir ne signifie pas avoir moins de possibilités. Cela signifie avoir plus de discernement.\n\n' +
    '## Savoir porter\n\n' +
    'Parce qu’un vêtement, un parfum, un bijou ou une couleur ne racontent jamais exactement la même histoire sur deux personnes.\n\n' +
    'Ce qui nous intéresse, c’est de comprendre les proportions, les codes, les associations et ces petits détails capables de transformer une image.\n\n' +
    'Mais aussi quelque chose de plus important : apprendre à nous approprier ce que nous portons sans devenir la copie de ce que nous voyons.\n\n' +
    'Le style apparaît là où la référence s’arrête et où commence votre interprétation.\n\n' +
    '## Savoir être\n\n' +
    'Ici commence une conversation essentielle pour CARO.\n\n' +
    'La présence ne se construit pas seulement avec ce qui se voit.\n\n' +
    'Elle se trouve aussi dans la manière d’entrer dans une pièce, d’écouter, de converser, de remercier, de répondre, de partager ce que l’on sait, de respecter les autres, de reconnaître le talent d’autrui ou d’aider une autre personne à briller.\n\n' +
    'Nous parlerons de comportement, d’éducation, de générosité, de caractère, d’humilité, de culture et de codes sociaux, parce que nous pensons que tout cela fait partie de l’image que nous projetons.\n\n' +
    'Vous pouvez vous habiller de façon impeccable et pourtant manquer d’élégance.\n\n' +
    'Car l’image peut attirer l’attention ; c’est le comportement qui finit par laisser une empreinte.\n\n' +
    'Edit veut ouvrir des conversations sur la mode et la beauté, mais aussi sur l’âge, l’identité, la culture, l’art, le design, les relations, la présence et ces gestes quotidiens qui semblent anodins et qui, pourtant, en disent énormément sur nous.\n\n' +
    'Nous ne prétendons pas établir de règles universelles ni vous dire comment vous devez être.\n\n' +
    'Nous voulons vous offrir des références, des expériences, des connaissances et des questions qui vous permettent de mieux observer, de questionner davantage et de décider par vous-même.\n\n' +
    'Car plus vous en savez, moins vous avez besoin de suivre.\n\n' +
    'Et plus vous développez votre discernement, plus vous êtes libre de choisir.\n\n' +
    '**SAVOIR CHOISIR · SAVOIR PORTER · SAVOIR ÊTRE**\n\n' +
    'Lire · observer · apprendre · questionner · choisir\n\n' +
    'S’habiller n’est que le début.',
  'edit.emptyTitle': 'Bientôt, d’autres articles',
  'edit.emptyMsg': 'Le contenu éditorial est en préparation.',
  'edit.cat.estilo': 'Style',
  'edit.cat.belleza': 'Beauté',
  'edit.cat.bienestar': 'Bien-être',
  'edit.cat.casa': 'Casa',
  'edit.cat.mujer-40': 'Femme 40+',
  'edit.shopBeauty': 'Voir la boutique beauté',
  'edit.shopEstilo': 'Voir la boutique style',
  'edit.shopCasa': 'Voir la boutique Casa',
  'edit.services': 'Voir le conseil en image',
  'edit.guide': 'Comment associer les couleurs de votre saison',
  'edit.catIntro.estilo':
    'Le style, ce n’est pas suivre les tendances : c’est apprendre à choisir ce qui vous représente vraiment. Vêtements, accessoires, couleur et proportions, à travers le regard de Carolina.\n\n' +
    'Des notes pour savoir choisir et savoir porter, toujours à partir d’une question essentielle : cela a-t-il du sens pour moi ? Comment intégrer une pièce de saison, comment vous habiller pour la femme que vous êtes aujourd’hui et comment ajouter sans accumuler. Car le style apparaît là où la référence s’arrête et où commence votre interprétation.',
  'edit.catIntro.belleza':
    'Prendre soin de sa beauté, ce n’est pas se corriger : c’est se reconnaître et savoir choisir. Nous écrivons du point de vue de l’image et du soin, pas du cabinet médical.\n\n' +
    'Vous trouverez ici comment organiser une routine avec moins de produits, bien choisis, quelles questions vous poser avant d’acheter et comment accompagner une peau qui change avec les années. Sans promesses impossibles ni clichés : la beauté avec discernement, pour la femme qui évolue.',
  'edit.catIntro.bienestar':
    'Le bien-être sans obsession : prendre soin de soi avec calme, sans viser la perfection ni se comparer à personne.\n\n' +
    'Nous parlons de petits soins du quotidien et de cette manière d’être qui fait aussi partie de l’image que nous projetons. Nous ne donnons ni conseils médicaux ni recettes universelles : nous partageons un regard serein pour que vous choisissiez ce qui a du sens pour vous. Car pour CARO, la beauté, le style, le bien-être et la présence forment une seule et même conversation.',
  'edit.catIntro.casa':
    'La maison parle aussi de vous. Bien décorer, ce n’est pas remplir l’espace, c’est savoir ce qui mérite de rester.\n\n' +
    'Nous parlons ici d’art, de design et d’objets de caractère, des créateurs que nous sélectionnons pour Casa et de la manière de vivre avec les pièces que nous choisissons. Une lampe, un livre ou une sculpture disent aussi qui vous êtes. Car la maison est un prolongement du style, et c’est aussi là que l’on apprend à savoir choisir.',
  'edit.catIntro.mujer-40':
    'Les années ne retirent pas de possibilités : elles aident à mieux choisir. Les 40+, un âge pour vivre avec intention et sans clichés.\n\n' +
    'Nous parlons ici de style, de beauté et de présence pour la femme qui évolue : s’habiller non plus pour ressembler à quelqu’un, mais pour se reconnaître. Des idées pour choisir avec plus de discernement, porter ce qui nous représente et être présente à chaque étape avec assurance et naturel.',
  'article.notFound': 'Article introuvable',
  'article.productsTitle': 'La sélection CARO',
  'share.label': 'Partager',
  'share.copy': 'Copier le lien',
  'share.copied': 'Lien copié',
  'share.more': 'Plus…',

  'contact.eyebrow': 'Échangeons',
  'contact.title': 'Contact',
  'contact.lede': 'Pour vos questions de style, vos commandes, la presse ou les collaborations.',
  'contact.send': 'Envoyer le message',
  'contact.thanks': 'Merci pour votre message. Nous vous répondrons personnellement.',
  'form.source.label': 'Comment nous avez-vous connus ? (facultatif)',
  'form.source.placeholder': 'Choisissez une option',
  'form.source.google': 'Google',
  'form.source.maps': 'Google Maps',
  'form.source.instagram': 'Instagram',
  'form.source.referral': 'Recommandation',
  'form.source.event': 'Événement en boutique',
  'form.source.press': 'Presse',
  'form.source.other': 'Autre',
  'contact.alsoHere': 'Également ici',
  // Labels carry their own colon (space before ':').
  'contact.emailLabel': 'E-mail :',
  'contact.instagramLabel': 'Instagram :',
  'contact.whatsappCta': 'Écrivez-moi sur WhatsApp',
  'contact.whatsappAria': 'Ouvrir WhatsApp pour écrire à CARO (s’ouvre dans un nouvel onglet)',
  'contact.privacyResponsable': 'Responsable du traitement :',
  'contact.privacyNote':
    'Nous traitons votre nom et votre adresse e-mail uniquement pour répondre à votre demande (base juridique : votre consentement). Nous ne les utilisons pas à des fins publicitaires et ne les cédons pas à cette fin. Vous pouvez exercer vos droits d’accès, de rectification, d’effacement et d’opposition. Plus d’informations dans la',
  'contact.privacyLink': 'Politique de confidentialité',
  'contact.legalTodo': 'TODO: CONTENT · informations légales de l’entreprise en attente.',

  'notfound.eyebrow': 'Erreur 404',
  'notfound.title': 'Cette page s’est égarée',
  'notfound.body': 'Le lien a peut-être changé. Revenons à la sélection.',

  'consent.title': 'Cookies',
  'consent.body':
    'Nous utilisons des cookies nécessaires au fonctionnement du site et, avec votre accord, des cookies d’analyse (Google Analytics) pour améliorer l’expérience.',
  'consent.accept': 'Tout accepter',
  'consent.reject': 'Nécessaires uniquement',
  'consent.more': 'Politique relative aux cookies',
  'consent.configure': 'Paramétrer les cookies',

  // Legal pages chrome (the documents themselves live in src/content/legal*.ts)
  'legal.metaTitle': 'Informations légales',
  'legal.eyebrow': 'Informations légales',
  'legal.notFound': 'Document introuvable',
  'legal.draftBadge': 'Brouillon. En attente de relecture juridique professionnelle',
  'legal.draftNote':
    'Ce document est un brouillon. Les données d’identification sont réelles ; les clauses doivent être relues et validées par un professionnel conformément au droit espagnol et à celui de l’Union européenne avant leur publication définitive.',

  // <head> titles of non-indexed or loading pages (indexable pages: lib/seo/pages.ts)
  'meta.checkout.title': 'Paiement',
  'meta.checkoutReturn.title': 'Confirmation',
  'meta.notFound.title': 'Page introuvable',
  'meta.product.title': 'Produit',
  'meta.article.title': 'Article',
};
